export default __webpack_public_path__ + "static/media/Laundry - Grey.52880c57.svg";